"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonCard = exports.PersonCardDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var person_cell_1 = require("./person-cell");
var use_lang_1 = require("../../hooks/use-lang");
var sprintf_js_1 = require("sprintf-js");
var entity_count_label_1 = require("./entity-count-label");
var lodash_1 = require("lodash");
var entity_value_1 = require("./entity-value");
var entity_link_value_1 = require("./entity-link-value");
var content_node_1 = require("./content-node");
var entity_list_1 = require("./entity-list");
exports.PersonCardDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " 0;\n    flex-grow: 1;\n    height: 100%;\n    box-sizing: border-box;\n    flex-direction: column;\n    border-bottom: 1px solid ", ";\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "], ["\n    padding: ", " 0;\n    flex-grow: 1;\n    height: 100%;\n    box-sizing: border-box;\n    flex-direction: column;\n    border-bottom: 1px solid ", ";\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "])), theme_1.theme.UNIT(1), theme_1.theme.COLOR('line-semi-subtle')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(6), theme_1.theme.UNIT(4))
});
var CellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-top: ", ";\n    margin-top: ", ";\n    ", ";\n  "], ["\n    padding-top: ", ";\n    margin-top: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3, 2), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG())
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var CountLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var LabelsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    width: 100%;\n  "], ["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    width: 100%;\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3))
});
var SitesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n    color: ", ";\n    width: 100%;\n  "], ["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n    color: ", ";\n    width: 100%;\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2), theme_1.theme.COLOR('dark'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  CountLabel: (0, styled_components_1.default)(entity_count_label_1.EntityFieldCountLabel)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), CountLabelStyles),
  Labels: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelsStyles),
  Cell: (0, styled_components_1.default)(person_cell_1.PersonCell)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Sites: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), SitesStyles)
};
var PersonCard = function (props) {
  var className = props.className,
    entity = props.entity;
  if (!entity) {
    return null;
  }
  var t = (0, use_lang_1.useLang)();
  var bio = entity.bio;
  var descriptionText = bio && bio.plainTruncated;
  var hasDescription = !!descriptionText;
  var label = props.label || t('Person');
  var isPending = !entity.isMember;
  var badge = entity.role && (isPending ? (0, sprintf_js_1.sprintf)(t('Pending Member'), entity.role.name) : (0, lodash_1.truncate)(entity.role.name, {
    length: 35
  }));
  var linkPerson = !!entity.slug;
  var impactStories = entity.impactStories,
    feedEntries = entity.feedEntries,
    chapterRoles = entity.chapterRoles,
    positions = entity.positions,
    organisation = entity.organisation,
    teamRoles = entity.teamRoles;
  var _a = entity.sites,
    sites = _a === void 0 ? [] : _a;
  var hasSites = !!sites.length;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Cell, {
    linkPerson: linkPerson,
    badge: badge,
    isPending: isPending,
    label: label,
    showLocation: true,
    showPosition: true,
    size: "large",
    entity: entity
  }), hasSites && react_1.default.createElement(My.Sites, {
    variant: 'card',
    items: sites
  }), organisation && react_1.default.createElement(My.LinkValue, {
    variant: "card",
    entity: organisation
  }), react_1.default.createElement(My.Labels, null, react_1.default.createElement(My.CountLabel, {
    entityTypeName: "ChapterRole",
    value: chapterRoles
  }), react_1.default.createElement(My.CountLabel, {
    entityTypeName: "TeamRole",
    value: teamRoles
  }), react_1.default.createElement(My.CountLabel, {
    entityTypeName: "ImpactStory",
    value: impactStories
  }), react_1.default.createElement(My.CountLabel, {
    entityTypeName: "FeedEntry",
    value: feedEntries
  })), hasDescription && react_1.default.createElement(My.Description, {
    size: "small",
    maxLines: 4,
    entity: bio
  }));
};
exports.PersonCard = PersonCard;
exports.PersonCard.defaultProps = exports.PersonCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;